import React from 'react';

interface IProps {
  text?: string;
}

const CheckList: React.FC<IProps> = ({ text }) => (
  <div className="flex items-center gap-2">
    <div className='bg-green-500 w-1.5 h-1.5 rounded-full' />
    <p className="text-xs">{text}</p>
  </div>
);

export default CheckList;
